import React from "react"
import { createScope } from "bunshi"
import { ScopeProvider } from "bunshi/react"
import { v4 as generateUUID } from "uuid"

export const NewCategoryModalScope = createScope<string | undefined>(undefined, {
  debugLabel: "NewCategoryModalScope",
})

export const NewCategoryModalScopeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const categoryId = `new-${generateUUID()}`

  return (
    <ScopeProvider scope={NewCategoryModalScope} value={categoryId}>
      {children}
    </ScopeProvider>
  )
}
